var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.shouldShowRegeneratePromptBlock
        ? _c("div", { staticClass: "pdp-prompt-regenerate mb-3" }, [
            _c("div", { staticClass: "pdp-prompt-regenerate__body" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "pdp-prompt-regenerate__content" }, [
                _c("div", { staticClass: "pdp-prompt-regenerate__title" }, [
                  _vm._v(
                    "\n          This report was generated with a different prompt\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pdp-prompt-regenerate__text" }, [
                  _vm._v("\n          Current report prompt:\n          "),
                  _c("strong", [_vm._v(_vm._s(_vm.currentReportPromptLabel))]),
                  _vm._v(".\n          Selected prompt:\n          "),
                  _c("strong", [_vm._v(_vm._s(_vm.selectedPromptLabel))]),
                  _vm._v(".\n        "),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn btn-success btn-sm pdp-prompt-regenerate__btn",
                attrs: { type: "button", disabled: _vm.isRegenerating },
                on: {
                  click: function ($event) {
                    return _vm.$emit("regenerate")
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "bi",
                  class: _vm.isRegenerating
                    ? "bi-hourglass-split"
                    : "bi-arrow-clockwise",
                }),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.isRegenerating
                        ? "Regenerating..."
                        : "Re-generate with selected prompt"
                    ) +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isDefaultTemplate
        ? _c("DefaultTemplate", {
            attrs: {
              "report-data": _vm.reportData,
              "analysis-content": _vm.analysisContent,
            },
          })
        : _vm.isContentTemplate
        ? _c("ContentTemplate", {
            attrs: {
              "analysis-content": _vm.analysisContent,
              images: _vm.reportData.images,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pdp-prompt-regenerate__icon" }, [
      _c("i", { staticClass: "bi bi-arrow-clockwise" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }